module.exports = __webpack_public_path__ + "static/media/prv2.26c72dc4.jpg";